import { Text, FocusTrap } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import CategoriaDeInovacaoForm from "../../components/categoria-de-inovacao-form";
import { TCategoriaInovacaoForm } from "../../firestore";

const CategoriaDeInovacaoFormModal = ({
  context,
  innerProps,
  id
}: ContextModalProps<{ item: TCategoriaInovacaoForm }>) => {
  const { item: categoria } = innerProps;
  /**
   * Handle add ignore area success
   */
  function onSuccess() {
    context.closeModal(id);
  }

  return (
    <FocusTrap active={true}>
      <Text fw="bold" mb="md">
        Cadastro de Categoria de inovação
      </Text>
      <CategoriaDeInovacaoForm categoria={categoria} onSuccess={onSuccess} />
    </FocusTrap>
  );
};

export default CategoriaDeInovacaoFormModal;
